import { StorageManagerActionTypes } from './types.mjs';

const addFilesAction = ({ files, status, getFileErrorMessage, }) => ({
    type: StorageManagerActionTypes.ADD_FILES,
    files,
    status,
    getFileErrorMessage,
});
const clearFilesAction = () => ({
    type: StorageManagerActionTypes.CLEAR_FILES,
});
const queueFilesAction = () => ({
    type: StorageManagerActionTypes.QUEUE_FILES,
});
const setProcessedKeyAction = (input) => ({
    ...input,
    type: StorageManagerActionTypes.SET_PROCESSED_FILE_KEY,
});
const setUploadingFileAction = ({ id, uploadTask, }) => ({
    type: StorageManagerActionTypes.SET_STATUS_UPLOADING,
    id,
    uploadTask,
});
const setUploadProgressAction = ({ id, progress, }) => ({
    type: StorageManagerActionTypes.SET_UPLOAD_PROGRESS,
    id,
    progress,
});
const setUploadStatusAction = ({ id, status, }) => ({
    type: StorageManagerActionTypes.SET_STATUS,
    id,
    status,
});
const removeUploadAction = ({ id }) => ({
    type: StorageManagerActionTypes.REMOVE_UPLOAD,
    id,
});

export { addFilesAction, clearFilesAction, queueFilesAction, removeUploadAction, setProcessedKeyAction, setUploadProgressAction, setUploadStatusAction, setUploadingFileAction };
